import React, { Fragment, useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  Grid,
  Chip,
  IconButton,
  Typography,
  CardContent,
  Divider,
} from "@material-ui/core";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
import * as api from "../../api/index.js";
import { useStyles } from "../ViewRestaurant/classes";

export default function DishCard({ item, idx, gets, getDishe, res, fMenu }) {
  const classes = useStyles();

  const [expandList, setExpandList] = useState([]);
   JSON.parse(localStorage.getItem("profile"));

  const handleExpand = (index) => {
    const isInclude = expandList.includes(index);
    if (isInclude) {
      // If already there remove
      setExpandList((prev) => prev.filter((e) => e !== index));
    } else {
      // If not there add to list
      setExpandList((prev) => [...prev, index]);
    }
  };

  const favoriteRemove = async (id) => {
    try {
       await api.removeFavd({
        type: "dish",
        id: id,
      });
      //  item = await axios.get(`dish/${id}`);
      // await getDishe();
      if (res) {
        await getDishe();
      } else {
        await gets();
      }

  
    } catch (error) {
      console.log(error);
    }
  };

  const favoriteAdd = async (id) => {
    try {
      await api.addToFavd({
        type: "dish",
        id: id,
      });
      // await getDishe();
      if (res) {
        await getDishe();
      } else {
        await gets();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Card className={classes.menuCard}>
      <CardContent className={classes.menuCardInner}>
        <Grid>
          <Grid item container direction="row">
            <Grid item container direction="row">
              <div item justifyContent="center" className={classes.cardImageWrap}>
                <CardMedia
                  className={classes.cardImg}
                  alt="complex"
                  image={item.image?item.image:"https://firebasestorage.googleapis.com/v0/b/retirement-cal.appspot.com/o/dish%2FGottaMenu-dishes-thumbnail.jpgTue%20Jun%2001%202021%2010%3A51%3A56%20GMT%2B0530%20(India%20Standard%20Time)?alt=media&token=6e31bfa0-e72c-4597-9d28-7482b06f6d86"}
                />

                {fMenu ? (
                  <IconButton
                    aria-label="add to favorites"
                    style={{
                      position: "absolute",
                      top: "3%",
                      right: "3%",
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      padding: "7px",
                    }}
                  >
                    <FavoriteIcon style={{ color: "red" }} fontSize="small" />
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="add to favorites"
                    style={{
                      position: "absolute",
                      top: "3%",
                      right: "3%",
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      padding: "7px",
                    }}
                    onClick={() =>
                      item.isFavorite
                        ? favoriteRemove(item._id)
                        : favoriteAdd(item._id)
                    }
                  >
                    {item.isFavorite ? (
                      <FavoriteIcon style={{ color: "red" }} fontSize="small" />
                    ) : (
                      <FavoriteBorderIcon
                        style={{ color: "#fff" }}
                        fontSize="small"
                      />
                    )}
                  </IconButton>
                )}
              </div>
              <div className={classes.section}>
                <Typography
                  gutterBottom
                  variant="subtitle1"
                  xs={12}
                  className={classes.menuCardHeader}
                >
                  {item.name}
                </Typography>
                <Typography
                  variant="body2"
                  xs={12}
                  gutterBottom
                  className={classes.cardDescription}
                  style={{ height: 75, width: "100%" }}
                >
                  {item.description}
                </Typography>
                <Grid
                  item
                  container
                //justify="space-between"
                >
                  <div
                    style={{
                      width: "100%",
                      marginTop: "2px",
                      marginBottom: "2px",
                    }}
                  >
                    <Box
                      display="flex "
                      flexWrap="wrap"
                      justifyContent="center"
                    >
                      <Box
                        flexGrow={1}
                        className={classes.calories}
                        display="inline"
                      >
                        {`${item.calories} Kcal`}
                      </Box>
                      <Box className={classes.price} display="inline">
                        {" "}
                        {`$${item.price}`}
                      </Box>
                    </Box>
                  </div>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    container
                    justifyContent="flex-start"
                  >
                    {item.tags.slice(0, 3).map((tag) => {
                      return (
                        <Chip
                          size="small"
                          className={classes.chip}
                          label={tag.name}
                          variant="outlined"
                          style={{
                            fontSize: "10px",
                          }}
                        />
                      );
                    })}
                    {item.tags.length > 3 && (
                      <Chip
                        size="small"
                        className={classes.expandchip}
                        label={`+${item.tags.length - 3}`}
                        variant="outlined"
                        style={{
                          fontSize: "10px",
                          color: "#f95919",
                          borderColor: "#f95919",
                        }}
                        onClick={() => handleExpand(idx)}
                      />
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>

            <Grid item md={12} className={classes.tagExpand}>
              {expandList.includes(idx) ? (
                <Fragment>
                  <Divider className={classes.divider} />
                  {item.tags.slice(3, item.tags.length).map((tag) => {
                    return (
                      <Chip
                        size="small"
                        className={classes.chip}
                        label={tag.name}
                        variant="outlined"
                        style={{
                          fontSize: "10px",
                          position: "relative",
                        }}
                      />
                    );
                  })}
                </Fragment>
              ) : (
                <Fragment></Fragment>
              )}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
